import { Component, OnInit, OnDestroy, Input, Inject } from '@angular/core';
import { Subscription } from 'rxjs';

import { ApiLotsDialogService } from '../../../../services/api/api-lots-dialog.service';
import { IFilterContractsByLot } from '../../../../models/filters';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { lotsList } from '../../../utils/base';
import { IContractLot, ILot, DetailLotEnum } from '../../../../models/generic';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IManagementContractsModalData } from 'src/app/models/dialog';

@Component({
  selector: 'app-list-contracts-dialog',
  templateUrl: './list-contracts-dialog.component.html',
  styleUrls: ['./list-contracts-dialog.component.scss']
})
export class ListContractsDialogComponent implements OnInit, OnDestroy {
  @Input() lotOrigin?: ILot;
  @Input() contractsInLots: Array<IContractLot> = [];
  @Input() typeLot: DetailLotEnum = this.data.template.typeLot!;
  action: 'view' | 'edit' = 'view';
  count: number = 0;

  contracts: Array<IContractLot> = [];
  contractsCheck: Array<IContractLot> = [];

  searchFieldSubscription?: Subscription;

  constructor(
    private _dialogService: ApiDialogService,
    private _lotsService: ApiLotsDialogService,
    @Inject(MAT_DIALOG_DATA) public data: IManagementContractsModalData
  ) {}

  ngOnInit(): void {
    this.listeningEvents();
    this.getContractListAPI();
  }

  ngOnDestroy(): void {
    if (this.searchFieldSubscription)
      this.searchFieldSubscription.unsubscribe();
  }

  listeningEvents(): void {
    this.searchFieldSubscription =
      this._dialogService.searchFieldEvent.subscribe({
        next: (response: string) => this.searchContractsAPI(response)
      });
  }

  filterBuilder(
    skip: number,
    take: number,
    text: string,
    bank: string,
    partner: string
  ): IFilterContractsByLot {
    return {
      Skip: skip,
      Take: take,
      Text: text,
      Bank: bank,
      Partner: partner
    };
  }

  getContractListAPI(
    text: string = '',
    skip: number = 0,
    take: number = 50
  ): void {
    this.action = 'view';

    let bank: string = this.lotOrigin?.Bank?.toLowerCase() ?? '';
    let partner: string = this.lotOrigin?.Partner?.toLowerCase() ?? '';
    const filter: IFilterContractsByLot = this.filterBuilder(
      skip,
      take,
      text,
      bank,
      partner
    );

    switch (this.typeLot) {
      case DetailLotEnum.Transfer:
        this.getContractListByPartnerTransfer(filter);
        this.data.template.typeLot = DetailLotEnum.Transfer;
        break;
      case DetailLotEnum.Invoicing:
        this.getContractListByBankInvoicing(filter);
        this.data.template.typeLot = DetailLotEnum.Invoicing;
        break;
    }
  }

  getContractListByBankInvoicing(filter: IFilterContractsByLot): void {
    this._lotsService.getContractListByBankInvoicing(filter).subscribe({
      next: (response) => {
        this.contracts = this.filterContractsData(response.Data);

        this.count = response.Count;
        this.action = 'edit';
      },
      error: (err) => (this.action = 'edit')
    });

    this.data.template.typeLot = DetailLotEnum.Invoicing;
  }

  getContractListByPartnerTransfer(filter: IFilterContractsByLot): void {
    this._lotsService.getContractListByPartnerTransfer(filter).subscribe({
      next: (response) => {
        this.contracts = this.filterContractsData(response.Data);

        this.count = response.Count;
        this.action = 'edit';
      },
      error: (err) => (this.action = 'edit')
    });

    this.data.template.typeLot = DetailLotEnum.Transfer;
  }

  checkUncheckContract(contract: IContractLot): void {
    let indexContract: number = this.contractsCheck.findIndex(
      (contractCheck) => contractCheck.Number === contract.Number
    );

    if (indexContract >= 0) this.contractsCheck.splice(indexContract, 1);
    else this.contractsCheck.push(contract);
  }

  checkContract(contract: IContractLot): boolean {
    const validateContractNumber = (ctt: IContractLot) =>
      ctt.Number === contract.Number;

    return this.contractsCheck.some(validateContractNumber);
  }

  searchContractsAPI(text: string): void {
    if (this.action !== 'view') {
      this.getContractListAPI(text, 0, 50);
    }
  }

  filterContractsData(contracts: IContractLot[]): Array<IContractLot> {
    const newContractsList: IContractLot[] = contracts.filter(
      (contract) =>
        !this.contractsInLots.some(
          (contractLot) => contractLot.ContractId === contract.ContractId
        )
    );

    return newContractsList ?? [];
  }
}
